<meta-liquid-toolbar 
    [config]="$toolbarConfig()" 
    [toolbarTools]="$toolbarTools()"
    [toolbarLinks]="$toolbarLinks()"
    (panelOpened)="$toolbarPanelOpened.set(true)"
    (panelClosed)="$toolbarPanelOpened.set(false)" />

<div class="h-full bg-gray-300">

    @if ($viewerConfig().showProgressBar) {
        <div class="w-full fixed top-0 h-[.625rem] bg-gray-400 z-1001" [ngClass]="{
            'top-[unset] bottom-0': $toolbarConfig().position === 'top',
            'z-998': $toolbarPanelOpened(),
        }"></div>

        @if ($progressBarSteps().length > 0) {
            @for (step of $progressBarSteps(); track $index) {
                <div class="fixed top-0 h-[.625rem] z-1002 bg-transparent box-border"
                    [style.width]="step.width  + '%'" [ngClass]="{
                    'top-[unset] bottom-0': $toolbarConfig().position === 'top',
                    'border-r-white border-r-[0.2rem]': !$last,
                    'z-998': $toolbarPanelOpened(),
                }"></div>
            }
        }

        <div class="fixed top-0 h-[.625rem] z-1002 bg-viewer-secondary w-0 current-progress-bar box-border border-r-white border-r-[0.2rem]" 
            [style.width]="($currentProgress()) + '%'" [ngClass]="{
            'top-[unset] bottom-0': $toolbarConfig().position === 'top',
            'z-998': $toolbarPanelOpened(),
        }">
            @if ($currentProgress() > 0 && $progressBarTooltip()) {
                <div class="fixed top-[.9rem] h-[1.5rem] z-1002 bg-transparent w-0 flex items-center justify-center current-progress-bar-tooltip transition-all duration-100"
                    [style.width]="($currentProgress()) + '%'" [ngClass]="{
                    'top-[unset] bottom-0': $toolbarConfig().position === 'top',
                    'z-998': $toolbarPanelOpened(),
                }">
                    <span [innerHTML]="$progressBarTooltip()"></span>
                </div>
            }
        </div>
    }

    @if ($createClipping()) {
        <div class="fixed top-[1.2rem] z-1002 bg-transparent w-full flex items-center justify-center">
            <div class="bg-white px-4 py-2 rounded-full shadow-lg" [innerHTML]="'Drag mouse on page to select area to crop' | translate"></div>
        </div>
    }

    <main class="h-full xl:pb-0 xl:pl-viewer-toolbar transition-all duration-300 flex items-center" [ngClass]="{
        'pb-viewer-toolbar md:mb-2 xl:pl-viewer-toolbar': $toolbarConfig().position === 'left',
        'pb-viewer-toolbar md:mb-2 xl:pr-viewer-toolbar': $toolbarConfig().position === 'right',
        'pb-viewer-toolbar md:pb-2': $toolbarConfig().position === 'bottom',
        'pt-viewer-toolbar md:pt-2': $toolbarConfig().position === 'top'
    }">
        <!-- Previous -->
        <div class="fixed z-10 mx-10 md:static bottom-viewer-toolbar left-0 right-1/2 h-viewer-toolbar flex justify-center items-center md:bottom-0 md:right-auto md:flex-col md:h-screen md:left-3 lg:left-12 3xl:left-48 4xl:left-[26rem]"
            [ngClass]="{
                'xl:left-24': $toolbarConfig().position === 'left'
            }">
            <div class="relative h-full w-full md:h-auto md:w-auto">
                <button [attr.aria-label]="'Back' | translate"
                    [attr.aria-disabled]="!hasPrevious()"
                    [disabled]="!hasPrevious()"
                    (click)="goPrevious()"
                    class="peer h-full w-full inline-flex items-center justify-center bg-gray-300 md:bg-primary md:text-gray-300 md:rounded-full md:h-auto md:w-auto md:p-2 disabled:opacity-20">
                    <meta-icon icon="angle-left" additionalClasses="text-2xl" class="flex"/>
                </button>
                <div id="ttpLArrow"
                    class="js-tooltip peer-hover:flex peer-focus-visible:flex animate__animated peer-hover:animate__fadeIn peer-focus-visible:animate__fadeIn hidden z-1000 absolute -top-10 left-[38%] md:left-[3.4rem] md:right-auto md:top-0 py-2 px-4 rounded-lg bg-black/60 text-white whitespace-nowrap">
                    {{'Back' | translate}}
                </div>
            </div>
        </div>

        <!-- Body -->
        <div class="w-full flex justify-center max-w-content mx-auto">
            <div class="liquid-page-container">
                <meta-liquid-page
                    class="relative"
                    [configuration]="$pageConfiguration()"
                    [pageContent]="$pageContent()"
                    [pageAnnotions]="$pageAnnotations()"
                    [showCut]="$createClipping()"
                    (createdCanvasDataUrl)="handleNewClipping($event)"
                    (createAnnotation)="createPageAnnotation($event)"
                    (openAnnotation)="openPageAnnotation($event)"
                    (updateAnnotation)="updatePageAnnotation($event)"
                    (deleteAnnotation)="deletePageAnnotation($event)"
                ></meta-liquid-page>
            </div>
        </div>

        <!-- Next -->
        <div class="fixed z-10 mx-10 md:static bottom-viewer-toolbar right-0 left-1/2 h-viewer-toolbar flex justify-center items-center md:bottom-0 md:left-auto md:flex-col md:h-screen md:right-3 lg:right-12 xl:right-16 3xl:right-40 4xl:right-96"
            [ngClass]="{
                'xl:right-24': $toolbarConfig().position === 'right'
            }">
            <div class="relative h-full w-full md:h-auto md:w-auto">
                <button [attr.aria-label]="'Next' | translate"
                    [attr.aria-disabled]="!hasNext()"
                    [disabled]="!hasNext()"
                    (click)="goNext()"
                    class="peer h-full w-full inline-flex items-center justify-center bg-gray-300 md:bg-primary md:text-gray-300 md:rounded-full md:h-auto md:w-auto md:p-2 disabled:opacity-20">
                    <meta-icon icon="angle-right" additionalClasses="text-2xl" class="flex"/>
                </button>
                <div role="tooltip" id="ttpRArrow"
                    class="js-tooltip peer-hover:flex peer-focus-visible:flex animate__animated peer-hover:animate__fadeIn peer-focus-visible:animate__fadeIn hidden absolute z-1000 -top-10 right-[38%] md:right-[3.4rem] md:left-auto md:top-0 py-2 px-4 rounded-lg bg-black/60 text-white whitespace-nowrap">
                    {{'Next' | translate}}
                </div>
            </div>
        </div>
    </main>
</div>

@if ($clippingToShow()) {
    <meta-popup [config]="$annotationPopupConfig()" [bodyTemplateRef]="clipping">
        <ng-template #clipping>
            <div class="flex flex-col gap-x-3">
                <div>
                    <label class="block text-[0.9375rem]">{{ 'Title' | translate }}</label>
                    <div class="mt-1">
                        <input class="h-10" type="text" id="clippingTitle" [value]="$clippingToShow()?.title" />
                    </div>
                </div>
                <div class="mt-6">
                    <label class="block text-[0.9375rem]">{{ 'Preview' | translate }}</label>
                    <img [src]="$clippingToShow()?.src" class="w-full border">
                </div>
            </div>
        </ng-template>
    </meta-popup>
}

@if ($linkToShow()) {
    <meta-popup [config]="$annotationPopupConfig()" [bodyTemplateRef]="link">
        <ng-template #link>
            <div class="flex flex-col gap-x-3">
                <div>
                    <label class="block text-[0.9375rem]">{{ 'URL' | translate }}</label>
                    <div class="mt-1">
                        <input class="h-10" type="text" id="linkUrl" [value]="$linkToShow()?.url" />
                    </div>
                </div>
            </div>
        </ng-template>
    </meta-popup>
}

@if ($noteToShow()) {
    <meta-popup [config]="$annotationPopupConfig()" [bodyTemplateRef]="note">
        <ng-template #note>
            <div class="flex flex-col gap-x-3">
                <div>
                    <label class="block text-[0.9375rem]">{{ 'Title' | translate }}</label>
                    <div class="mt-1">
                        <input class="h-10" type="text" id="noteTitle" [value]="$noteToShow()?.title" />
                    </div>
                </div>
                <div class="mt-6">
                    <label class="block text-[0.9375rem]">{{ 'Text' | translate }}</label>
                    <div class="mt-1">
                        <textarea id="noteText" class="resize-none" rows="5" [value]="$noteToShow()?.text"></textarea>
                    </div>
                </div>
            </div>
        </ng-template>
    </meta-popup>
}